function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { AnalyticsReporter } from './AnalyticsReporter';
// List events that are produced a lot by the frontend since the legacy
// reporter sends one request per event. Events can still be read through the
// AEL path.
const FREQUENT_EVENTS = new Set([
    'frontend.data.success',
    'frontend.data.permissions_success',
    'frontend.data.permissions_error',
    'frontend.data.prefetch.hover.abort.350ms',
    'frontend.data.prefetch.hover.success.350ms',
    'frontend.data.overprefetch',
    'frontend.data.underprefetch',
    'frontend.data.revamp.debug',
    'preloaded_experiment_retrieved'
]);
export class DualReporter {
    injectGoogleAnalytics() {
        return !!this.aelReporter.config.googleAnalytics || !!this.deprecatedReporter.config.googleAnalytics;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    configure(params) {
        this.aelReporter.configure(params);
        this.deprecatedReporter.configure(params);
    }
    callLogFiltered(eventName, experimentName, // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    loggerFn) {
        if (this.filterExperiments(eventName, experimentName, this.experimentsList)) {
            return loggerFn();
        }
    }
    trackOnce(eventName, params = {}, options = {}, onTrackingIssue) {
        this.callLogFiltered(eventName, params.experiment_name, ()=>this.deprecatedReporter.trackOnce(eventName, params, options, onTrackingIssue));
        return this.aelReporter.trackOnce(eventName, params, options, onTrackingIssue);
    }
    track(eventName, params = {}, options = {}, doubleSnakeCase = true, // eslint-disable-next-line @typescript-eslint/no-empty-function
    onTrackingIssue = ()=>{}) {
        if (!FREQUENT_EVENTS.has(eventName)) {
            this.callLogFiltered(eventName, params.experiment_name, ()=>this.deprecatedReporter.track(eventName, params, options, doubleSnakeCase, onTrackingIssue));
        }
        return this.aelReporter.track(eventName, params, options, doubleSnakeCase, onTrackingIssue);
    }
    viewedOnce(eventName, params = {}, options = {}) {
        this.callLogFiltered(eventName, params.experiment_name, ()=>this.deprecatedReporter.viewedOnce(eventName, params, options));
        return this.aelReporter.viewedOnce(eventName, params, options);
    }
    viewed(eventName, params = {}, options = {}) {
        this.callLogFiltered(eventName, params.experiment_name, ()=>this.deprecatedReporter.viewed(eventName, params, options));
        return this.aelReporter.viewed(eventName, params, options);
    }
    modalOnce(eventName, params = {}, options = {}) {
        this.callLogFiltered(eventName, params.experiment_name, ()=>this.deprecatedReporter.modalOnce(eventName, params, options));
        return this.aelReporter.modalOnce(eventName, params, options);
    }
    modal(eventName, params = {}, options = {}) {
        this.callLogFiltered(eventName, params.experiment_name, ()=>this.deprecatedReporter.modal(eventName, params, options));
        return this.aelReporter.modal(eventName, params, options);
    }
    actionOnce(eventName, params = {}, options = {}) {
        this.callLogFiltered(eventName, params.experiment_name, ()=>this.deprecatedReporter.actionOnce(eventName, params, options));
        return this.aelReporter.actionOnce(eventName, params, options);
    }
    action(eventName, params = {}, options = {}) {
        this.callLogFiltered(eventName, params.experiment_name, ()=>this.deprecatedReporter.action(eventName, params, options));
        return this.aelReporter.action(eventName, params, options);
    }
    linkOnce(eventName, params = {}, options = {}) {
        this.callLogFiltered(eventName, params.experiment_name, ()=>this.deprecatedReporter.linkOnce(eventName, params, options));
        return this.aelReporter.linkOnce(eventName, params, options);
    }
    link(eventName, params = {}, options = {}) {
        this.callLogFiltered(eventName, params.experiment_name, ()=>this.deprecatedReporter.link(eventName, params, options));
        return this.aelReporter.link(eventName, params, options);
    }
    getPreviousEventId() {
        // Both reporters eventId's should be in sync, just return the aelReporter one
        return this.aelReporter.getPreviousEventId();
    }
    constructor(aelConfig, deprecatedConfig, experimentsList, filterExperiments){
        _define_property(this, "aelReporter", void 0);
        _define_property(this, "deprecatedReporter", void 0);
        _define_property(this, "experimentsList", void 0);
        _define_property(this, "filterExperiments", void 0);
        this.aelReporter = new AnalyticsReporter(aelConfig);
        this.deprecatedReporter = new AnalyticsReporter(deprecatedConfig);
        this.experimentsList = experimentsList;
        this.filterExperiments = filterExperiments;
    }
}

//# sourceMappingURL=DualReporter.js.map